var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifySign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_2564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09184 0.5L7.43878 2.04545L4.86735 1.5L3.85714 3.77273L1.65306 4.31818L1.92857 6.77273L0 8.5L1.37755 10.4091L0.642857 12.5909L2.7551 13.9545L3.03061 16.3182H5.69388L7.34694 18.5L9.09184 17.0455L11.2959 18.3182L12.5816 16.3182H15.0612L15.4286 13.9545L17.5408 12.5909L16.7143 10.4091L18 8.5L16.2551 6.77273L16.4388 4.31818L14.4184 3.77273L13.2245 1.5L10.8367 2.04545L9.09184 0.5Z",
    fill: "#25D366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96964 9.31617L5.05127 10.4182L8.17372 13.2652L13.4084 6.92842L12.2145 5.91821L7.89821 11.0611L5.96964 9.31617Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_2564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifySign);
export default __webpack_public_path__ + "static/media/verify-sign.75c10f50dd42dce7a7dbcd77800a1034.svg";
export { ForwardRef as ReactComponent };